const Divider = () => (
  <div
    style={{
      width: '100%',
      height: '1px',
      minHeight: '1px',
      backgroundColor: '#e9ecef',
    }}
  ></div>
);

export default Divider;
